import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'rk-add-new-stream',
  templateUrl: './add-new-stream.component.html',
  styleUrl: './add-new-stream.component.scss',
  standalone: false,
})
export class AddNewStreamComponent {
  @Output() readonly addStream = new EventEmitter<void>();

  addNewStream() {
    this.addStream.emit();
  }
}
